import { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import axios from "axios";
import { API } from "../App";
import { Button } from "../components/ui/button";
import { Input } from "../components/ui/input";
import { Label } from "../components/ui/label";
import { Card, CardContent, CardHeader, CardTitle, CardDescription } from "../components/ui/card";
import { LogIn, Briefcase } from "lucide-react";
import { toast } from "sonner";

const PortalLoginPage = () => {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      const response = await axios.post(`${API}/portal/auth/login`, { email, password });
      localStorage.setItem("portalToken", response.data.token);
      toast.success("Portal login successful");
      navigate("/portal");
    } catch (error) {
      toast.error(error.response?.data?.detail || "Portal login failed");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen bg-background flex items-center justify-center p-6">
      <Card className="w-full max-w-md border-primary/20">
        <CardHeader>
          <CardTitle className="flex items-center gap-3 text-2xl"><Briefcase className="h-6 w-6 text-primary" /> Worker Portal</CardTitle>
          <CardDescription>Sign in to manage your availability and bookings.</CardDescription>
        </CardHeader>
        <CardContent>
          <form onSubmit={handleSubmit} className="space-y-4">
            <div className="space-y-2"><Label>Email</Label><Input type="email" value={email} onChange={(e) => setEmail(e.target.value)} required className="bg-muted/50" /></div>
            <div className="space-y-2"><Label>Password</Label><Input type="password" value={password} onChange={(e) => setPassword(e.target.value)} required className="bg-muted/50" /></div>
            <Button type="submit" disabled={loading} className="w-full bg-primary hover:bg-primary/90">
              {loading ? "Signing in..." : <span className="flex items-center gap-2"><LogIn size={16} /> Sign in</span>}
            </Button>
          </form>
          <div className="mt-6 border-t border-border pt-4 text-sm text-muted-foreground text-center space-y-2">
            <div>
              Don&apos;t have a portal account?{" "}
              <Link to="/portal/register" className="text-primary hover:underline font-medium">
                Create one
              </Link>
            </div>
            <div>
              Got an invite from your contractor? Use the link in your email to claim access.
            </div>
          </div>
        </CardContent>
      </Card>
    </div>
  );
};

export default PortalLoginPage;
